import { CxEvent } from '@spartacus/core';

export class Ga4GgFindADealerSearchEvent extends CxEvent {
  event?: string;
  type?: string;
  search_term?: string;
  visitor_type?: string;
}
